import { ApiClient } from "../api.client";
import {
  CancelEventRequest,
  CancelEventResponse,
  GetEventRequest,
  GetEventResponse,
  GetEventsRequest,
  GetEventsResponse,
} from "./types";

const EventsApi = {
  getAll(params: GetEventsRequest) {
    return ApiClient.get<GetEventsResponse>("/admin/events", {
      params,
    });
  },
  getOne({ eventId }: GetEventRequest) {
    return ApiClient.get<GetEventResponse>(`/admin/events/${eventId}`);
  },
  cancel({ eventId, ...body }: CancelEventRequest) {
    return ApiClient.post<
      Omit<CancelEventRequest, "eventId">,
      CancelEventResponse
    >(`/admin/events/${eventId}/cancel`, body);
  },
};

export { EventsApi };
